const EvaluatorPaymentViewsEnum = {
  AllPaymentRequests: 'All Payment Requests',
  MyOfficePendingApproval: 'My Office Pending Approval',
  MyPaymentRequestsPendingApproval: 'My Payment Requests Pending Approval',
  MyOfficePaymentRequestsPendingApproval: 'My Office Payment Requests Pending Approval',
  PendingApproval: 'Pending Approval',
  PendingReview: 'Pending Review',
  MyOfficePendingReview: 'My Office Pending Review',
  MyPaymentRequests: 'My Payment Requests',
  MyOfficeEmptyPayments: 'My Office Empty Payments',
  MyPaymentRequestsInformationRequired: 'My Payment Requests Information Required',
  AllEmptyPayments: 'All Empty Payments',
  MyOfficePaymentRequests: 'My Office Payment Requests',
  AllPendingApproval: 'All Pending Approval',
  PendingApprovalVAT: 'Pending Approval VAT',
};

export default EvaluatorPaymentViewsEnum;
